module.exports = __webpack_public_path__ + "Brandon_med.a989c5b7849027ec20bc.otf";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/fonts/brandon-grotesque/Brandon_med.otf
// module id = ../../../../../src/assets/fonts/brandon-grotesque/Brandon_med.otf
// module chunks = main